import { useState } from "react";
import {TextButton, Button, FlexBox, Modal, Title, Body, Loader} from "components";
import {useDeleteFormFileMutation, useDeleteProjectFileMutation, useDeleteTaskFileMutation} from "services/api/api.slice";
import { useDispatch } from "hooks/redux";
import { setNotification } from "services";


export interface DeletePackagingManagerFolderModalProps {
  onClose: Function;
  onComplete: Function;
  folderName: string;
}

const DeletePackagingManagerFolderModal = ({
                           onClose,
                           onComplete,
                           folderName,
                         }: DeletePackagingManagerFolderModalProps) => {
  
  
  const handleClose = (e: any) => {
    e.stopPropagation();
    onClose();
  };
  const handleComplete = (e: any) => {
    e.stopPropagation();
    onComplete();
  };
  
  return (
    <Modal open={true} testId="delete-pm-file-modal" onClose={handleClose}>
      <FlexBox maxWidth="100%" className="delete-file-modal">
        <Title size="large" bold pd="0 0 0.5rem">
          Delete folder:
        </Title>
        <Title size="small" bold pd="0 0 2rem">
           {folderName}
        </Title>
          <Body size="large" pd="0 0 2rem">
            Are you sure you want to delete this folder? Files associated with briefs will be removed from the folder and displayed with other loose files. Project or task files will be deleted, meaning they will be permanently removed and no longer accessible.
          </Body>
          <FlexBox row gap="1.5rem" align="center" justify="flex-start">
            <Button testId="submit-button" use="primary" onClick={handleComplete}>
              Delete folder
            </Button>
            <TextButton data-testid="cancel-button" onClick={handleClose}>
              Cancel
            </TextButton>
          </FlexBox>
      </FlexBox>
    </Modal>
  );
};

export default DeletePackagingManagerFolderModal;
